import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class BulkSmsStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'BulkSmsStore',
			properties: [
				'allMessages',
				'selectedMessage',
				'allProspects',
				'messagePayload',
			],
		});
	}

	allMessages = [];
	selectedMessage = {};
	allProspects= [];
	messagePayload={};

	reset = () => {
		this.allMessages = [];
		this.selectedMessage = {};
		this.allProspects = [];
		this.messagePayload={};
	};


	setAllMessages = async state => {
		runInAction(async () => {
			this.allMessages = state;
		});
	};

	setSelectedMessage = async state => {
		runInAction(async () => {
			this.selectedMessage = state;
		});
	};

	setAllProspects = async state => {
		runInAction(async () => {
			this.allProspects = state;
		});
	};

	setMessagePayload = async state => {
		runInAction(async () => {
			this.messagePayload = state;
		});
	};
	
}
